// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"48434f63","879":"b2459a72"}[chunkId] + ".chunk.js";
};